import posthog, { type Properties } from 'posthog-js';

const isEnabled = Boolean(import.meta.env.VITE_POSTHOG_KEY);
let initialized = false;

// Always-on: this status page collects no PII, just page views, so there's
// no cookie-consent gate to wait on (unlike the main Pokor app).
export function initPostHog(): void {
    if (!isEnabled || initialized) {
        return;
    }

    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
        api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://eu.i.posthog.com',
        ui_host: 'https://eu.posthog.com',
        defaults: '2026-01-30',
    });

    initialized = true;
}

export function usePostHog() {
    function capture(event: string, properties: Properties = {}): void {
        if (!initialized) {
            return;
        }

        posthog.capture(event, properties);
    }

    function captureException(error: unknown): void {
        if (!initialized) {
            return;
        }

        posthog.captureException(error);
    }

    return { capture, captureException };
}
